module.exports = __webpack_public_path__ + "img/modulo_SaveDate.0d09edc.svg";